import { AfterViewInit, Directive, HostListener, OnDestroy, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[creditCardFormatter]',
    standalone: false
})
export class CreditCardFormatterDirective implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject();

  constructor(@Self() private ngControl: NgControl) {}

  ngOnDestroy(): void {
    this.setValue(this.unformatValue(this.ngControl.value));
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.setValue(this.formatCreditCard(this.ngControl.value));
    this.ngControl.control?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(this.updateValue.bind(this));
  }

  updateValue(value: string): void {
    let inputVal = value || '';
    this.setValue(!!inputVal ? this.validateDecimalValue(inputVal.replace(/[^0-9.]/g, '')) : '');
  }

  @HostListener('focus') onFocus(): void {
    this.setValue(this.unformatValue(this.ngControl.value));
  }

  @HostListener('blur') onBlur(): void {
    let value = this.ngControl.value || '';
    !!value && this.setValue(this.formatCreditCard(value));
  }

  formatCreditCard(value: string): string {
    const newValue: String = value;
    if (newValue !== null) {
      for (let i = 6; i < newValue.length && i <= 11; i++) {
        value = this.insertXCharacter(value, i);
      }
    }
    return value;
  }

  insertXCharacter(str: string, index: number): string {
    return str.substr(0, index) + 'X' + str.substr(index + 1);
  }

  unformatValue(value: string): string {
    return value?.replace(/,/g, '');
  }

  validateDecimalValue(value: string): string {
    // Check to see if the value is a valid number or not
    if (Number.isNaN(Number(value))) {
      // Strip out last char as this would have made the value invalid
      const strippedValue = value.slice(0, value.length - 1);

      // If value is still invalid, then this would be copy/paste scenario
      // and in such case we simply set the value to empty
      return Number.isNaN(Number(strippedValue)) ? '' : strippedValue;
    }
    return value;
  }

  setValue(value: string): void {
    this.ngControl.control?.setValue(value, { emitEvent: false });
  }
}
